import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { email: String, username: String }

  connect() {
    this.element.addEventListener('auto-complete:change', event => this.loadEmailContent(event))
  }

  loadEmailContent(event) {
    fetch(`/tickets/support_template.json?template_id=${event.detail.id}&email=${this.emailValue}&username=${this.usernameValue}`)
    .then((response) => response.json())
    .then((data) => {
      const trixEditor = this.element.querySelector("trix-editor")

      if (trixEditor && trixEditor.editor) {
        trixEditor.editor.loadHTML(data.body);
      } else {
        console.error("Trix editor non trouvé ou non initialisé.");
      }
    })
    .catch(error => console.error(error));
  }
}